<div class="p-3" div *transloco="let t">
    <p-card [header]="t('access_denied')" styleClass="ngx-color">
        <div>
            {{ t('access_denied_details') }}
        </div>
    </p-card>
</div>